<template>
  <button
      type="button"
      class="pill-btn"
      :class="{ active: modelValue }"
      :aria-pressed="modelValue"
      @click="handleToggle"
  >
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
          d="M3 10v4h4l5 5V5l-5 5H3zm12.5 2a4.5 4.5 0 0 0-2.2-3.86v7.72A4.5 4.5 0 0 0 15.5 12zm-2.2-9.4v2.06a7.5 7.5 0 0 1 0 14.68v2.06a9.5 9.5 0 0 0 0-18.8z"
          fill="currentColor"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const handleToggle = (): void => {
  emit('update:modelValue', !props.modelValue);
};
</script>
